import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { getStationRelevance } from '@/api/powerStation'
import {
  AccessDevice,
  Device,
  Gateway,
  ModFun,
  StationMqttServer,
  Station,
  StationVirtualLabel,
  StationVirtualPoint,
} from '@/type/stationType'
import MqttServer from '@/utils/mqttUtil'
import { getGatewayStatus } from '@/utils/getStatus'
import useGlobalConfigStore from './globalConfig'
import appConfig from '@/config'
import formatDate from '@/utils/formatDate'

interface StationState {
  station: Station[]
  access_device: AccessDevice[]
  device: Device[]
  device_type: { code_id: string; code_name: string }[]
  gateway: Gateway[]
  mod_funs: ModFun[]
  mqtt_server: StationMqttServer[]
  mqtt_serve: MqttServer[]
  station_type: { code_id: string; code_name: string }[]
  station_status_type: { code_id: string; code_name: string }[]
  station_virtual_label: StationVirtualLabel[]
  station_virtual_point: StationVirtualPoint[]
}

interface StationAction {
  stationInit: () => Promise<void>
}

const useStationListStore = create<StationState & StationAction>()(
  immer((set) => ({
    station: [],
    access_device: [],
    device: [],
    device_type: [],
    gateway: [],
    mod_funs: [],
    mqtt_server: [],
    mqtt_serve: [],
    station_type: [],
    station_status_type: [],
    station_virtual_label: [],
    station_virtual_point: [],

    stationInit: async () => {
      let res: any, res2: any
      useGlobalConfigStore.getState().setInitFinished(false)
      useGlobalConfigStore.getState().setLoading(true)
      try {
        res = await getStationRelevance()
      } catch (e) {
        console.log(e)
        useGlobalConfigStore.getState().setLoading(false)
        throw new Error('Get Station error')
      }
      const data: any = res.data

      data.station_virtual_point.map((point: any) => {
        const target = data.station_virtual_label.find((label: any) => label.id === point.label_id)
        if (target) {
          if (target.points) {
            target.points.push(point)
          } else {
            target.points = [point]
          }
        }
      })

      //  mqtt
      let mqttServe: MqttServer[] = [],
        promiseArr: Promise<any>[] = []
      data.mqtt_server.map((server: any) => {
        promiseArr.push(
          new Promise((resolve, reject) => {
            mqttServe[server.mqtt_id] = new MqttServer({
              mqtt_host: server.mqtt_host_ip,
              mqtt_ws_port: Number(server.mqtt_host_ws_port),
              mqtt_user: server.mqtt_user,
              mqtt_pwd: server.mqtt_pwd,
            })
            mqttServe[server.mqtt_id].init(resolve, reject)
          })
        )
      })
      try {
        res2 = await Promise.all(promiseArr)
      } catch (e) {
        console.log(e)
        useGlobalConfigStore.getState().setLoading(false)
        throw new Error('Mqtt Init error')
      }

      //  gateway
      for (let oneGateway of data.gateway) {
        let gatewayStatus: any
        try {
          gatewayStatus = await getGatewayStatus(mqttServe[oneGateway.mqtt_server_id], oneGateway.uuid)
          if (!gatewayStatus.status) {
            useGlobalConfigStore.getState().setLoading(false)
            throw new Error('Get Gateway Status Error')
          }
        } catch (e) {
          console.log(e)
          useGlobalConfigStore.getState().setLoading(false)
          throw new Error('Get Gateway Status Error')
        }
      }

      data.device.forEach((oneDevice: Device) => {
        const targetAccessDevice = data.access_device.find(
          (item: AccessDevice) => item.serial_no === oneDevice.iot_serial_no
        )
        if (targetAccessDevice) {
          oneDevice.device_id = targetAccessDevice.device_id
          oneDevice.device_code = targetAccessDevice.device_code
          oneDevice.parent_id = targetAccessDevice.parent_id
        }
        oneDevice.mqtt_server_id = data.gateway.find(
          (item: Gateway) => item.uuid === oneDevice.iot_gateway_uuid
        )?.mqtt_server_id
        oneDevice.device_pic =
          appConfig.staticFile + 'static/images/product/' + appConfig.prefix.toLowerCase() + '/' + oneDevice.device_pic
      })

      data.station.forEach((station: any) => {
        station.station_image = JSON.parse(station.station_image) as string[]
        station.status_name = data.station_status_type.find((item: any) => item.code_id === station.status).code_name
        station.devices = data.device.filter((item: Device) => item.station_id === station.id)
        station.create_time = formatDate(new Date(station.create_time))
        station.update_time = formatDate(new Date(station.update_time))
        station.label = data.station_virtual_label.filter((item: any) => item.station_id === station.id)
      })

      set((state) => {
        state.station = data.station
        state.access_device = data.access_device
        state.device = data.device
        state.device_type = data.device_type
        state.gateway = data.gateway
        state.mod_funs = data.mod_funs
        state.mqtt_server = data.mqtt_server
        state.mqtt_serve = mqttServe
        state.station_type = data.station_type
        state.station_status_type = data.station_status_type
        state.station_virtual_label = data.station_virtual_label
        state.station_virtual_point = data.station_virtual_point
      })
      useGlobalConfigStore.getState().setLoading(false)
      useGlobalConfigStore.getState().setInitFinished(true)
    },
  }))
)

export default useStationListStore
